module.exports = __webpack_public_path__ + "static/img/aboutus.9ffde82e.png";